var _defs, _rect, _g, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAwsDevops(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    role: "img",
    "aria-label": "AWS DevOps",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#22c55e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f172a"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: 64,
    fill: "url(#g)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162 256c0-52 42-94 94-94s94 42 94 94-42 94-94 94-94-42-94-94z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 144v40M256 328v40M144 256h40M328 256h40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210 256h92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302 256l-20-20M302 256l-20 20"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 256,
    y: 420,
    textAnchor: "middle",
    fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, Arial",
    fontSize: 56,
    fontWeight: 700,
    fill: "#ffffff"
  }, "\n    DEVOPS\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsDevops);
export default __webpack_public_path__ + "static/media/aws_devops.f7086015bb0e7f0dbc504b628d892b6c.svg";
export { ForwardRef as ReactComponent };